module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bread-4a6aaeb3f08a62f050273707664c6acc.svg";